<template>
  <div class="next-page-wrapper d-flex justify-content-center mt-3 mb-4">
    <div class="next-page-control">
      <button
        type="button"
        class="next-page-arrow arrow-left"
        :class="{ 'is-disabled': currentPage <= 1 }"
        :style="{ color: currentPage > 1 ? arrowColor : undefined }"
        :disabled="currentPage <= 1"
        :aria-label="prevAriaLabel"
        @click="goPrevious"
      >&lt;</button>
      <span class="next-page-label" :style="{ color: labelColor }">{{ label }}</span>
      <button
        type="button"
        class="next-page-arrow arrow-right"
        :class="{ 'is-disabled': currentPage >= lastPage }"
        :style="{ color: currentPage < lastPage ? arrowColor : undefined }"
        :disabled="currentPage >= lastPage"
        :aria-label="nextAriaLabel"
        @click="goNext"
      >&gt;</button>
    </div>
  </div>
</template>

<script setup lang="ts">
type GoToPage = (page: number) => Promise<void> | void;

const props = defineProps({
  currentPage: { type: Number, required: true },
  lastPage: { type: Number, required: true },
  label: { type: String, required: true },
  prevAriaLabel: { type: String, required: true },
  nextAriaLabel: { type: String, required: true },
  goToPage: { type: Function as unknown as () => GoToPage, required: true },
  scrollTarget: { type: Object as () => HTMLElement | null, default: null },
  // Cores opcionais (default = identidade da página de Modelos). Permite
  // reaproveitar o controle em outros contextos, ex.: Área Gold (branco/dourado).
  labelColor: { type: String, default: "#666666" },
  arrowColor: { type: String, default: "#b20000" },
});

async function goNext() {
  if (props.currentPage >= props.lastPage) return;
  await props.goToPage(props.currentPage + 1);
  props.scrollTarget?.scrollIntoView({ behavior: "smooth", block: "start" });
}

async function goPrevious() {
  if (props.currentPage <= 1) return;
  await props.goToPage(props.currentPage - 1);
  props.scrollTarget?.scrollIntoView({ behavior: "smooth", block: "start" });
}
</script>

<style scoped>
.next-page-control {
  display: flex;
  align-items: center;
  gap: 18px;
  font-family: 'Bebas-Neue';
  font-weight: 900;
  font-size: 20px;
  letter-spacing: 1px;
  padding: 10px 20px;
}
.next-page-label {
  color: #666666;
  font-family: 'Bebas-Neue';
  font-weight: 700;
  font-size: 25px;
  line-height: 32px;
  vertical-align: middle;
}
.next-page-label:hover {
  color: #666666;
}
.next-page-arrow {
  background: transparent;
  border: none;
  padding: 0;
  font-family: inherit;
  font-weight: inherit;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.next-page-arrow.arrow-left,
.next-page-arrow.arrow-right {
  color: #b20000;
}
.next-page-arrow.is-disabled,
.next-page-arrow:disabled {
  color: #cccccc;
  cursor: not-allowed;
}

@media screen and (max-width: 769px) {
  .next-page-control {
    font-size: 16px;
    gap: 12px;
  }
  .next-page-arrow {
    font-size: 18px;
  }
}
</style>
